import i18n from "@/i18n";

const routes = {
  path: "/member",
  name: "Member",
  component: () =>
    import(/* webpackChunkName: "member" */ "@/views/member/Main"),
  children: [
    {
      path: "memberlist",
      alias: "",
      name: "MemberList",
      component: () =>
        import(/* webpackChunkName: "member" */ "@/views/member/MemberList"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.membership.member_list"),
        step: [
          i18n.t("page.membership.membership"),
          i18n.t("page.membership.member_list"),
        ],
        menu_num: 1,
        sub_menu_num: 11,
        location: "/member/memberlist",
      },
    },
    {
      path: "memberview/:playerno",
      name: "MemberView",
      component: () =>
        import(/* webpackChunkName: "member" */ "@/views/member/MemberView"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.membership.member_view"),
        step: [
          i18n.t("page.membership.membership"),
          i18n.t("page.membership.member_list"),
        ],
        menu_num: 1,
        sub_menu_num: 11,
        location: "/member/memberlist",
      },
    },
    {
      path: "ownerlist",
      name: "OwnerList",
      component: () =>
        import(/* webpackChunkName: "member" */ "@/views/member/OwnerList"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.membership.owner_list"),
        step: [
          i18n.t("page.membership.membership"),
          i18n.t("page.membership.owner_list"),
        ],
        menu_num: 1,
        sub_menu_num: 12,
        location: "/member/ownerlist",
      },
    },
    {
      path: "ownerwrite",
      name: "OwnerWrite",
      component: () =>
        import(/* webpackChunkName: "member" */ "@/views/member/OwnerWrite"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.membership.owner_write"),
        step: [
          i18n.t("page.membership.membership"),
          i18n.t("page.membership.owner_list"),
        ],
        menu_num: 1,
        sub_menu_num: 12,
        location: "/member/ownerlist",
      },
    },

    {
      path: "owneredit/:ownerno",
      name: "OwnerEdit",
      component: () =>
        import(/* webpackChunkName: "member" */ "@/views/member/OwnerEdit"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.membership.owner_edit"),
        step: [
          i18n.t("page.membership.membership"),
          i18n.t("page.membership.owner_list"),
        ],
        menu_num: 1,
        sub_menu_num: 12,
        location: "/member/ownerlist",
      },
    },
    {
      path: "handilist",
      name: "HandiList",
      component: () =>
        import(/* webpackChunkName: "member" */ "@/views/member/HandiList"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.membership.x_handicap"),
        step: [
          i18n.t("page.membership.membership"),
          // i18n.t("page.membership.x_handicap"),
        ],
        menu_num: 1,
        sub_menu_num: 13,
        location: "/member/handilist",
      },
    },
    {
      path: "pointlist",
      name: "PointList",
      component: () =>
        import(/* webpackChunkName: "member" */ "@/views/member/PointList"),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.membership.x_point"),
        step: [
          i18n.t("page.membership.membership"),
          i18n.t("menu.membership.x_point"),
        ],
        menu_num: 1,
        sub_menu_num: 14,
        location: "/member/pointlist",
      },
    },
  ],
};

export default routes;
